<template>
  <!--begin::Iconbox-->
  <b-card
    :class="
      `card stacked--up card-custom mt-6 cardround module-cards ${card.color}-opacity`
    "
    no-body
    v-if="isProfileLoaded"
  >
    <div class="card-body pb-0">
      <b-dropdown
        class="dropdown dropdown-inline ml-2 corner-dropdown"
        toggle-class="btn btn-sm btn-icon btn-clean"
        menu-class="dropdown-menu p-0 m-0"
        size="sm"
        offset="10"
        right
        :no-caret="true"
      >
        <template slot="button-content">
          <i class="ki ki-bold-more-ver"></i>
        </template>
        <template slot="default">
          <ul class="navi navi-hover">
            <li class="navi-item">
              <a class="navi-link" @click="goToCardDetail">
                <!-- <span class="navi-icon">
                  <i class="flaticon2-next"></i>
                </span> -->
                <span class="navi-text">{{
                  $t("messages.profile.modules.actions.details")
                }}</span>
              </a>
            </li>
            <li class="navi-item">
              <router-link
                :to="{ name: 'Assets', params: { family: card.id } }"
                class="navi-link"
              >
                <!-- <span class="navi-icon">
                  <i class="flaticon2-next"></i>
                </span> -->
                <span class="navi-text">{{
                  $t("messages.profile.modules.actions.docs")
                }}</span>
              </router-link>
            </li>
            <li class="navi-item" v-if="pendingInteraction">
              <a class="navi-link" @click="openChat(card.id)">
                <!-- <span class="navi-icon">
                  <i class="flaticon2-next"></i>
                </span> -->
                <span class="navi-text">{{
                  $t("messages.profile.modules.actions.next")
                }}</span>
              </a>
            </li>
          </ul>
        </template>
      </b-dropdown>
      <div :class="`floating-top top-icon ${card.color}`">
        <i :class="`fa tcicon ${card.icon}`" v-if="card.icon"></i>
        <span :class="`svg-icon svg-icon-4x svg-icon-white`" v-if="card.image">
          <simple-svg :src="require(`@/assets/images/icons/${card.image}`)" />
        </span>
      </div>
      <div class="d-flex align-items-center p-2 pt-6">
        <div class="d-flex flex-column text-center" style="width: 100%;">
          <span>
            <router-link
              v-if="titleLink"
              class="text-dark text-hover-primary font-weight-bolder font-size-h3 mb-3"
              :to="{ name: titleLink }"
              v-html="card.title"
            ></router-link>
            <span
              v-else-if="link && card.progress"
              style="cursor:pointer;"
              @click="goToCardDetail"
              class="text-dark text-hover-primary font-weight-bolder font-size-h3 mb-3"
              v-html="card.title"
            ></span>
            <router-link
              v-else-if="link && !card.progress"
              class="text-dark text-hover-primary font-weight-bolder font-size-h3 mb-3"
              :to="card.to"
              v-html="card.title"
            ></router-link>
            <span
              v-else
              class="text-dark font-weight-bold font-size-h4 mb-3"
              v-html="card.title"
            ></span>
          </span>
          <div class="text-dark-65 pt-4">
            {{ card.shortDesc }}
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer d-flex align-items-left border-0 pt-0">
      <router-link
        :to="{ name: 'Assets', params: { family: card.id } }"
        class="svg-icon svg-icon-outline-danger svg-icon-2x flex-shrink-0 text-dark-75"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path d="M5.857 2h7.88a1.5 1.5 0 01.968.355l4.764 4.029A1.5 1.5 0 0120 7.529v12.554c0 1.79-.02 1.917-1.857 1.917H5.857C4.02 22 4 21.874 4 20.083V3.917C4 2.127 4.02 2 5.857 2z" fill="#000" fill-rule="nonzero" opacity=".3"/><rect fill="#000" x="6" y="11" width="9" height="2" rx="1"/><rect fill="#000" x="6" y="15" width="5" height="2" rx="1"/></g></svg>
        <span class="font-weight-bolder">
          {{ assetsAvailables.files.length }}
        </span>
      </router-link>
      <router-link
        :to="{ name: 'Assets', params: { family: card.id } }"
        class="svg-icon svg-icon-outline-danger svg-icon-2x flex-shrink-0 ml-4 text-dark-75"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path d="M9.829 18.277l6.74-5.88a.5.5 0 00.002-.752L9.83 5.728a.5.5 0 00-.83.376V17.9a.5.5 0 00.829.377z" fill="#000"/></g></svg>
        <span class="font-weight-bolder">
          {{ assetsAvailables.videos.length }}
        </span>
      </router-link>
      <div class="d-flex flex-grow-1 ml-2" v-if="nextInteractionDate !== false">
        <div class="w-100 text-right">
          <span
            class="label label-rounded label-inline label-lg label-outline-danger font-weight-bolder"
          >
            <i class="text-danger la la-clock mr-2" />
            <span class="font-weight-bolder flex-shrink-0">{{
              nextInteractionDate
            }}</span>
          </span>
        </div>
      </div>
    </div>
  </b-card>
  <!--end::Iconbox-->
</template>

<script>
import _ from "lodash";
import { SimpleSVG } from "vue-simple-svg";

import { mapActions, mapGetters } from "vuex";
import moment from "moment-timezone";

export default {
  name: "Module",
  components: {
    "simple-svg": SimpleSVG
  },
  data() {
    return {
      isHovering: false
    };
  },
  props: {
    card: {
      type: Object,
      required: true
    },
    link: {
      type: Boolean,
      required: false,
      default: true
    },
    titleLink: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapGetters("Profile", [
      "getNextIterationByModule",
      "isProfileLoaded",
      "assets"
    ]),
    buttonIcon() {
      if (this.card) {
        if (parseFloat(this.card.progress) >= 100) {
          return "flaticon-eye";
        } else if (parseFloat(this.card.progress) > 0) {
          return "flaticon2-fast-next";
        } else if (this.card.status === "blocked") {
          return "flaticon-clock-1";
        } else {
          return "flaticon2-next";
        }
      } else {
        return "flaticon-clock-1";
      }
    },
    progressClass() {
      if (this.card && parseFloat(this.card.progress) > 0) {
        if (parseFloat(this.card.progress) >= 75) {
          return "primary";
        } else if (parseFloat(this.card.progress) >= 50) {
          return "warning";
        } else if (this.card.status === "blocked") {
          return "default";
        } else {
          return "danger";
        }
      } else {
        return "default";
      }
    },
    nextInteractionDate() {
      var last = this.getNextIterationByModule(this.card.id);
      if (last) {
        return moment().isAfter(last.userStartDate) &&
          (last.percentage === "100" || moment().isAfter(last.userEndDate))
          ? false
          : moment().to(last.userStartDate);
      } else {
        return false;
      }
    },
    assetsAvailables() {
      return {
        files: _.filter(
          this.assets,
          asset =>
            asset.family === this.card.id && !_.includes(asset.type, "_iframe")
        ),
        videos: _.filter(
          this.assets,
          asset =>
            asset.family === this.card.id && _.includes(asset.type, "_iframe")
        )
      };
    },
    pendingInteraction() {
      var last = this.getNextIterationByModule(this.card.id);
      if (last) {
        return (
          moment().isAfter(last.userStartDate) && last.percentage !== "100"
        );
      }
      return false;
    }
  },
  methods: {
    ...mapActions("Chatbot", ["activate"]),
    moment(value) {
      return moment(value);
    },
    getRandomNumberBetween(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    openChat(id) {
      var session = this.getNextIterationByModule(id);
      this.activate({ surveyEntityId: session.surveyEntityId });
    },
    goToCardDetail() {
      if (this.card.to) {
        this.$router.push(this.card.to);
      } else {
        switch (this.card.status) {
          case "done":
            this.$router.push({
              name: "TrainingDetail",
              params: { id: this.card.surveyEntityId }
            });
            break;
          case "progress":
          case "pending":
            this.activate({ surveyEntityId: this.card.surveyEntityId });
            this.$root.$emit("bv::show::modal", "chatbot");
            break;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.topcard {
  height: auto;
  padding: 2rem;
  .tcicon {
    font-size: 4rem;
  }
}

.corner-dropdown {
  position: absolute;
  right: 10px;
  top: 15px;
}
.navi-link {
  cursor: pointer;
}
$animation-timing: 0.3s;
$animation-ease: ease-in-out;
$animation-ease-bounce: cubic-bezier(0.175, 0.885, 0.32, 1.275);
[class*="stacked--"] {
  position: relative;
  transition: transform $animation-timing $animation-ease;
  will-change: transform;

  &:before,
  &:after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: transform $animation-timing $animation-ease;
    will-change: transform;
  }

  &:before {
    z-index: -1;
  }

  &:after {
    z-index: -2;
  }
}
.stacked--up {
  &:before,
  &:after {
    transform-origin: center bottom;
    border-radius: 30px;
  }
  transform: translate(0, -5px);
  &:before {
    transform: translate(0, 5px) scale(1);
    border-radius: 30px;
    background-color: transparent;
    box-shadow: 0 -3px 3px 0px rgb(0 0 0 / 6%) !important;
  }
  &:after {
    transform: translate(0, 10px) scale(1);
    z-index: -1;
    border-radius: 30px;
    background-color: transparent;
    box-shadow: 0 -3px 3px 0px rgb(0 0 0 / 6%) !important;
  }
}
.bg-light-tc1 {
  background-color: #cabbab20;
}
.bg-light-tc2 {
  background-color: #a1a3d320;
}
.bg-light-tc3 {
  background-color: #ce93b820;
}
.bg-light-tc4 {
  background-color: #afd3ca20;
}
.bg-light-tc5 {
  background-color: #f3c33c20;
}
.bg-light-tc6 {
  background-color: #7fc6ef20;
}
</style>
